import { AnimatePresence, motion } from 'framer-motion';
import { dismissToast, useToasts } from '@app/lib/toast';

export function ToastViewport() {
  const toasts = useToasts();

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="true">
      <AnimatePresence initial={false}>
        {toasts.map((toast) => (
          <motion.button
            key={toast.id}
            type="button"
            className={`toast toast--${toast.tone}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            transition={{ duration: 0.18, ease: 'easeOut' }}
            onClick={() => dismissToast(toast.id)}
            aria-label={`Dismiss notification: ${toast.message}`}
          >
            <span className="toast-indicator" aria-hidden="true" />
            <span>{toast.message}</span>
          </motion.button>
        ))}
      </AnimatePresence>
    </div>
  );
}
